<section *ngIf="this.gameConfig.sliderName === 'noslider'">
    <div class="">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                            <!-- <h4>{{portalName}}</h4> -->
                            <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                            <p>{{this.gameConfig.description}}</p>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex" *ngFor="let item of gameConfig.imageList; let i = index;">
                            <img [src]="item" class="img-fluid" alt="image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>

  <section class="mb-4 mt-4">
    <div class="container">
      <div class="row">
        <div class="col-12 d-flex justify-content-between">
          <h3 class="section-heading"><span class="text-theme-green">{{gameConfig.recommended}}</span></h3>
        </div>
        <div class="col-6 col-xl-3 col-md-4 mt-lg-0 mb-2" *ngFor="let item of recommendList">
          <div class="custom-card" *ngIf="this.gameConfig.name == 'game'">
            <div class="card-img" *ngIf="item.cdm_url != ''">
              <!-- <a href="./assets/detail.html"> -->
                <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1">
              <!-- </a> -->
            </div>
            <div class="card-img" *ngIf="item.cdm_url == ''">
              <!-- <a href="./assets/detail.html"> -->
                <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
              <!-- </a> -->
            </div>
            <div class="card-text">
              <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
            </div>
          </div>
          <div class="custom-card" *ngIf="this.gameConfig.name != 'game'">
            <div class="card-img">
              <!-- <a href="./assets/detail.html"> -->
                <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
              <!-- </a> -->
            </div>
            <div class="card-text">
              <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>

  <section class="mb-4 mt-4" *ngIf="queryParam.id == '16'">
    <div class="container">
      <div class="row">
        <div class="col-12 d-flex justify-content-between">
          <h3 class="section-heading"><span class="text-theme-green">Puzzle and Logic Games</span></h3>
        </div>
        <div class="col-6 col-xl-3 col-md-4 mt-lg-0 mb-2" *ngFor="let item of contentList">
          <div class="custom-card" *ngIf="this.gameConfig.name == 'game'">
            <div class="card-img" *ngIf="item.cdm_url != ''">
              <!-- <a href="./assets/detail.html"> -->
                <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1">
              <!-- </a> -->
            </div>
            <div class="card-img" *ngIf="item.cdm_url == ''">
              <!-- <a href="./assets/detail.html"> -->
                <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
              <!-- </a> -->
            </div>
            <div class="card-text">
              <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
            </div>
          </div>
          <div class="custom-card" *ngIf="this.gameConfig.name != 'game'">
            <div class="card-img">
              <!-- <a href="./assets/detail.html"> -->
                <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
              <!-- </a> -->
            </div>
            <div class="card-text">
              <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>